export const DAMAGE_INSURANCE_VA_TYPE = 'td'

export function isDamageInsuranceVaorder (vaorder) {
  return String(vaorder?.vaType || '').toLowerCase() === DAMAGE_INSURANCE_VA_TYPE
}

export function findBlockingUnfinishedVaorder (vaorders) {
  if (!Array.isArray(vaorders)) return undefined
  return vaorders.find(vaorder => {
    return !isDamageInsuranceVaorder(vaorder) &&
      String(vaorder.vaStatus) !== '9' &&
      String(vaorder.vaPayStatus) === '9'
  })
}

export function checkParcelServiceOrders (parcels) {
  const parcelList = Array.isArray(parcels) ? parcels : []
  const unPayParcel = parcelList.find(parcel => {
    return parcel.vaorders?.some(vaorder => String(vaorder.vaPayStatus) === '1')
  })
  if (unPayParcel) return { ok: false, reason: 'service-unpaid', parcel: unPayParcel }

  const unDoParcel = parcelList.find(parcel => findBlockingUnfinishedVaorder(parcel.vaorders))
  if (unDoParcel) return { ok: false, reason: 'service-unfinished', parcel: unDoParcel }
  return null
}
